// extracted by mini-css-extract-plugin
module.exports = {"imgLogo":"inicio-module--img-logo--2HLvG"};